import React from "react";
import { SimpleForm, EditProps, useEditController } from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomEditToolbar from "components/CustomEditToolbar";
import EditWrapper from "../../components/EditWrapper";
import BusScheduleInput from "./components/BusScheduleInput";
import CustomDatePickerInput from "../../components/CustomDatePickerInput";
import moment from "moment";
import PermissionLoading from "../../components/PermissionLoading";

const DryRunScheduleEdit = (props: EditProps) => {
  const { id } = props;
  const { record, loading } = useEditController(props);

  const breadcrumb = [
    { link: "/dryRunSchedules", title: "Dry Run Schedules" },
    { link: `/dryRunSchedules/${id}`, title: id },
  ];

  const formatRecord = (res: any) => {
    if (res) {
      if (res.busSchedules) {
        res.busScheduleIds = res.busSchedules.map((item: any) => {
          return item ? item.id : item;
        });
      }

      return res;
    }
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper breadcrumb={breadcrumb} isDefaultTitle {...props}>
        <SimpleForm
          record={formatRecord(record)}
          toolbar={<CustomEditToolbar />}
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Wave Information</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <BusScheduleInput />
            </Grid>
            <Grid item xs={12} md={8}></Grid>

            <Grid item xs={12} md={4}>
              <CustomDatePickerInput
                name="date"
                label="Select Date *"
                min={moment().add(1, "day").format("Y-MM-DD")}
              />
            </Grid>
            <Grid item xs={12} md={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default DryRunScheduleEdit;
